import { ClientInferRequest, ClientInferResponseBody } from "@ts-rest/core";

import { contract } from "#app/http/api";
import { api } from "#app/http/api";
import { ApiError } from "#shared/infra/apiError";

export type UpdatePart = ClientInferResponseBody<typeof contract.parts.updatePart>;

export type UpdatePartDto = ClientInferRequest<typeof contract.parts.updatePart>["body"];

export const updatePart = async ({
  id,
  payload,
}: {
  id: string;
  payload: UpdatePartDto;
}): Promise<UpdatePart> => {
  const response = await api.parts.updatePart.mutation({
    params: {
      id,
    },
    body: payload,
  });

  if (response.status === 200) {
    return response.body;
  }

  throw new ApiError("Failed to update Part", response.status, response.body);
};
